import { render } from "./EnrolleeSingleOnboardComponent.vue?vue&type=template&id=3c767cc0&scoped=true"
import script from "./EnrolleeSingleOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeSingleOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeSingleOnboardComponent.vue?vue&type=style&index=0&id=3c767cc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c767cc0"]])

export default __exports__